import React from "react";

const ContactSection = () => {
  return (
    <section className="bg-[#D7F3EF] py-20">
      <div className="max-w-7xl mx-auto px-6">

        {/* Header */}
        <div className="flex items-center justify-between mb-10">
          <h2 className="text-2xl md:text-3xl font-semibold text-[#0F172A]">
            Contact Us
          </h2>

          <span className="text-xs text-[#64748B] border border-[#E2E8F0] bg-white px-3 py-1 rounded-full">
            London • Berlin • Remote
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">

          {/* LEFT FORM */}
          <div className="bg-white rounded-2xl p-8 shadow-sm">
            <form className="space-y-4">

              <Input label="Full name" placeholder="Jane Doe" />
              <Input label="Business email" placeholder="jane@company.com" />
              <Input label="Monthly invoice volume" placeholder="PKR 100k – PKR 500k" />

              <div>
                <label className="block text-xs text-[#64748B] mb-1">
                  Message
                </label>
                <textarea
                  rows={4}
                  placeholder="Tell us about your business needs..."
                  className="w-full border border-[#E2E8F0] rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#00B3A4]"
                />
              </div>

              <button
                type="submit"
                className="bg-[#00B3A4] text-white text-sm font-semibold px-4 py-2.5 rounded-md hover:bg-[#009688] transition"
              >
                Request a Demo
              </button>
            </form>
          </div>

          {/* RIGHT INFO */}
          <div className="bg-white rounded-2xl p-8 shadow-sm flex flex-col gap-6">

            <div>
              <h4 className="text-sm font-semibold text-[#0F172A] mb-1">
                Our offices
              </h4>
              <p className="text-sm text-[#64748B]">
                We partner with regulated financial institutions across the EU and UK.
              </p>
            </div>

            {/* Map */}
            <div className="rounded-xl overflow-hidden border border-[#E2E8F0] h-[220px]">
              <iframe
                title="Office locations"
                src="https://maps.google.com/maps?q=london&t=&z=11&ie=UTF8&iwloc=&output=embed"
                className="w-full h-full border-0"
                loading="lazy"
              />
            </div>

            {/* Contact details */}
            <div className="space-y-3">
              <ReadOnlyField label="Email" value="hello@invexflow.com" />
              <ReadOnlyField label="Phone" value="+44 20 1234 5678" />
            </div>

          </div>

        </div>
      </div>
    </section>
  );
};

/* ---------- Subcomponents ---------- */

const Input = ({ label, placeholder }) => (
  <div>
    <label className="block text-xs text-[#64748B] mb-1">
      {label}
    </label>
    <input
      type="text"
      placeholder={placeholder}
      className="w-full border border-[#E2E8F0] rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#00B3A4]"
    />
  </div>
);

const ReadOnlyField = ({ label, value }) => (
  <div>
    <label className="block text-xs text-[#64748B] mb-1">
      {label}
    </label>
    <div className="border border-[#E2E8F0] rounded-lg px-4 py-3 text-sm text-[#0F172A] bg-[#F8FAFC]">
      {value}
    </div>
  </div>
);

export default ContactSection;
